import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlay, FaPause } from 'react-icons/fa';
import '../styles/MainPage.css';
import lightBackground from '../assets/main.png';
import darkBackground from '../assets/dark-mode.png';
import sampleMusic from '../assets/music.mp3';
import { FaSun, FaMoon,  } from 'react-icons/fa';


const MainPage = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(new Audio(sampleMusic));
  const navigate = useNavigate();

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const startDictionary = () => {
    navigate('/dictionary?lang=en');  // Always navigate to the English dictionary
  };

  return (
    <div
      className="container"
      style={{
        backgroundImage: `url(${darkMode ? darkBackground : lightBackground})`,
        color: darkMode ? '#fff' : '#000',
      }}
    >
      <header className="main-header">
        <button className="music-button" onClick={togglePlay}>
          {isPlaying ? <FaPause /> : <FaPlay />}
        </button>
        <button className="theme-button" onClick={toggleTheme}>
                    {darkMode ? <FaSun /> : <FaMoon />}
                </button>
      </header>
      <div className='title-container'>
        <h1 className='title'>WordWave</h1>
        <img
          src="https://media1.giphy.com/media/Z968Qd9K6UBO4uj7Oc/giphy.gif?cid=6c09b952zfgy5w9hjbayk84akcryzi7859egss3xvn4wg1en&ep=v1_internal_gif_by_id&rid=giphy.gif&ct=s"
          alt="Main GIF"
          className="main-gif"
        />
      </div>
      <div className="dictionary">
        <h2>Dictionary</h2>
        <button onClick={startDictionary}>Press Start</button>
      </div>
      
    </div>
    
  );
};

export default MainPage;
